var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.247 15.4179C18.4 15.4179 20.956 12.8619 20.956 9.70895C20.956 6.55599 18.4 4 15.247 4C12.0941 4 9.53809 6.55599 9.53809 9.70895C9.53809 12.8619 12.0941 15.4179 15.247 15.4179Z",
    stroke: "#00842F",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62418 25.5498L13.9219 25.5498",
    stroke: "#00842F",
    strokeWidth: 2.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0064 26.2694V25.0021C26.0064 19.7985 21.6322 15.5801 16.2365 15.5801H13.794C10.8447 15.5801 8.20054 16.8405 6.40918 18.8332",
    stroke: "#00842F",
    strokeWidth: 2.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2002 21L0.145647 25.2406C0.0994525 25.2794 0.0624561 25.3272 0.0371146 25.3807C0.0117731 25.4342 -0.00133276 25.4922 -0.00133276 25.5509C-0.00133276 25.6096 0.0117731 25.6677 0.0371146 25.7212C0.0624561 25.7747 0.0994525 25.8224 0.145647 25.8612L5.20019 30.1027",
    fill: "#00842F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.be7cfca3.svg";
export { ForwardRef as ReactComponent };